import styled from 'styled-components'
import {
  communicationButtonCss,
  communicationTitleCss,
} from '~/pages/communication/libs/communicationBaseStyles'
import { COLORS } from '~/shared/constants/uiConstants'

export const Styles = {
  Root: styled.div`
    width: 100%;
    height: calc(100dvh - var(--header-height));
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: ${COLORS.WHITE};
    overflow: hidden;
  `,

  ContentWrapper: styled.div`
    width: 100%;
    max-width: 375px;
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;
  `,

  ScrollContent: styled.div`
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    padding: 24px 16px 0;
    gap: 24px;
  `,

  Title: styled.h1`
    ${communicationTitleCss}
    text-align: center;
  `,

  ComparisonWrapper: styled.div`
    display: flex;
    gap: 12px;
  `,

  Column: styled.div<{ $isAfter?: boolean }>`
    position: relative;
    flex: 1;
    border-radius: 16px;
    background: ${({ $isAfter }) => ($isAfter ? '#cddcec' : COLORS.WHITE)};
    border: 2px solid ${({ $isAfter }) => ($isAfter ? '#cddcec' : '#eaeaed')};
    display: flex;
    flex-direction: column;
    padding: 12px 0;
  `,

  ColumnHeaderPill: styled.span<{ $isAfter?: boolean }>`
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(0, -50%);
    font-family: 'Mulish', sans-serif;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.2;
    padding: 4px 12px;
    border-radius: 8px;
    background: ${({ $isAfter }) => ($isAfter ? '#096ef9' : '#eaeaed')};
    color: ${({ $isAfter }) => ($isAfter ? '#ffffff' : '#17202a')};
  `,

  ItemList: styled.div`
    display: flex;
    flex-direction: column;
    padding: 0 8px;
  `,

  Item: styled.div<{ $isAfter?: boolean }>`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
    padding: 8px 0;
    text-align: center;

    &:not(:last-child) {
      border-bottom: 1px dashed
        ${({ $isAfter }) => ($isAfter ? '#ffffff' : '#eaeaed')};
    }
  `,

  ItemEmoji: styled.span`
    font-size: 34px;
    line-height: 1;
  `,

  ItemText: styled.p`
    font-family: 'Poppins', sans-serif;
    font-size: 12px;
    font-weight: 600;
    line-height: 1.2;
    color: #17202a;
    min-height: 34px;
    display: flex;
    align-items: flex-start;
    justify-content: center;
  `,

  ButtonWrapper: styled.div`
    padding: 16px 16px 24px;
  `,

  Button: styled.button`
    ${communicationButtonCss}
  `,
} as const
